import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventsService {

  public events;
  public calendar;
  public currentEvent;
  public tempEvents;

  public onEventChange: BehaviorSubject<any>;
  public onCurrentEventChange: BehaviorSubject<any>;
  public onCalendarChange: BehaviorSubject<any>;

  constructor() {
    this.onEventChange = new BehaviorSubject({});
    this.onCurrentEventChange = new BehaviorSubject({});
    this.onCalendarChange = new BehaviorSubject({});
  }

  getEvents(): Promise<any[]> {
    const url = `api/calendar-events`;

    return new Promise((resolve, reject) => {

    });
  }

  /**
   * Get Calendar
   */
  getCalendar(): Promise<any[]> {
    const url = `api/calendar-filter`;

    return new Promise((resolve, reject) => {

    });
  }

  /**
   * Create New Event
   */
  createNewEvent() {

  }

  /**
   * Calendar Update
   *
   * @param calendars
   */
  calendarUpdate(calendars) {

  }

  /**
   * Delete Event
   *
   * @param event
   */
  deleteEvent(event) {

  }

  /**
   * Add Event
   *
   * @param eventForm
   */
  addEvent(eventForm) {

  }

  /**
   * Update Event
   *
   * @param eventRef
   */
  updateCurrentEvent(eventRef) {

  }

  /**
   * Post New Event
   */
  postNewEvent() {

  }

  /**
   * Post Updated Event
   *
   * @param event
   */
  postUpdatedEvent(event) {

  }
}
